// (function () {
//   function initGlobalControls() {
//     var mobileDropButton = document.getElementById('mobile-dropbtn');
//     if (mobileDropButton) {
//       mobileDropButton.addEventListener('click', function () {
//         var dropdown = mobileDropButton.closest('.dropdown-mobile');
//         var content = dropdown && dropdown.querySelector('.dropdown-content');
//         if (!content) return;
//         content.style.display = window.getComputedStyle(content).display === 'none' ? 'block' : 'none';
//       });
//     }

//     var announcementBar = document.querySelector('.announcement-bar');
//     var breadcrumbs = document.querySelectorAll('.breadcrumbs-container-updated');
//     if (announcementBar && breadcrumbs.length) {
//       var updateBreadcrumbs = function () {
//         var visible = window.scrollY > announcementBar.offsetHeight;
//         breadcrumbs.forEach(function (element) {
//           element.style.display = visible ? '' : 'none';
//         });
//       };
//       document.addEventListener('scroll', updateBreadcrumbs, { passive: true });
//       updateBreadcrumbs();
//     }

//     var now = new Date();
//     var currentDay = now.getDay();
//     var openingTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 7, 0);
//     var closingTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 30);
//     var isOpen = now > openingTime && now < closingTime;
//     if (currentDay !== 6 && currentDay !== 0 && isOpen) {
//       document.querySelectorAll('.openstatus').forEach(function (element) {
//         element.style.display = window.getComputedStyle(element).display === 'none' ? '' : 'none';
//       });
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initGlobalControls, { once: true });
//   } else {
//     initGlobalControls();
//   }
// })();

// Product Video Pop-up
function videoPop() {
  document.getElementById("product-video-popup").style.display = "grid";
}

function shippingVideoPop() {
  document.getElementById("product-shipping-video-popup").style.display = "grid";
}

function closeVideo() {
  document.getElementById("product-video-popup").style.display = "none";
  document.getElementById("product-shipping-video-popup").style.display = "none";
}
// Product bf Coupon
function bfPop() {
  document.getElementById("bf-popup").style.display = "grid";
}

function closeBf() {
  document.getElementById("bf-popup").style.display = "none";
}


// Cyber Monday Pop-up
function cyberPop() {
  document.getElementById("cyber-popup").style.display = "grid";
}

function closeCyber() {
  document.getElementById("cyber-popup").style.display = "none";
}

// let text06 = document.getElementById('icon-coupon-cyber').innerText;
//   const copyCodeC = async () => {
//     try {
//       await navigator.clipboard.writeText(text06);
//       console.log('Content copied to clipboard');
//     } catch (err) {
//       console.error('Failed to copy: ', err);
//     }
//   }
// Showroom pick-up promo modal. Only rendered on product templates, so this
// runs site-wide but must tolerate the element being absent.
function showroompickupPop() {
  var el = document.getElementById("showroom-promo-pickup-popup");
  if (el) el.style.display = "grid";
}

function closeshowroompickupPop() {
  var el = document.getElementById("showroom-promo-pickup-popup");
  if (el) el.style.display = "none";
}

          document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('toggle-description');
  var desc = document.getElementById('collection-description');

  if (toggle && desc) {
    toggle.addEventListener('click', function () {
      desc.classList.toggle('expanded');
      var isExpanded = desc.classList.contains('expanded');
      toggle.textContent = isExpanded ? toggle.dataset.seeLess : toggle.dataset.seeMore;
      toggle.setAttribute('aria-expanded', isExpanded.toString());
    });
  }
});


          
  document.addEventListener("DOMContentLoaded", function () {
    document.body.classList.add("announcement-offset");
  });

(function () {
  var scriptPromises = {};
  var zendeskConfigured = false;

  function loadScript(id, src) {
    if (scriptPromises[id]) return scriptPromises[id];

    scriptPromises[id] = new Promise(function (resolve) {
      var existingScript = document.getElementById(id);
      if (existingScript) {
        if (existingScript.dataset.loaded === 'true') {
          resolve(true);
          return;
        }
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', function () { resolve(false); }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve(true);
      }, { once: true });
      script.addEventListener('error', function () { resolve(false); }, { once: true });
      document.head.appendChild(script);
    });

    return scriptPromises[id];
  }

  function configureZendesk() {
    if (zendeskConfigured || typeof window.zE !== 'function') return;
    zendeskConfigured = true;
    window.zE('webWidget', 'hide');
    window.zE('webWidget:on', 'close', function () {
      window.zE('webWidget', 'hide');
    });
  }

  window.tmgLoadZendesk = function () {
    return loadScript(
      'ze-snippet',
      'https://static.zdassets.com/ekr/snippet.js?key=58a78508-fbd3-41d3-a85e-bf5c23d41d74'
    ).then(configureZendesk);
  };

  window.openZendeskWidget = function (event) {
    if (event) event.preventDefault();
    window.tmgLoadZendesk().then(function () {
      if (typeof window.zE === 'function') {
        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');
      }
    });
  };

  function setupZendesk() {
    var loadZendesk = function () {
      window.tmgLoadZendesk();
    };
    var triggers = document.querySelectorAll(
      '.quick-contact-badge-email, [data-zendesk], [onclick*="openZendeskWidget"]'
    );

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', loadZendesk, { once: true });
      trigger.addEventListener('focus', loadZendesk, { once: true });
      trigger.addEventListener('touchstart', loadZendesk, { once: true, passive: true });
      trigger.addEventListener('pointerdown', loadZendesk, { once: true, passive: true });
    });

    var launcher = document.getElementById('tmg-zendesk-launcher');
    if (launcher) {
      launcher.addEventListener('click', window.openZendeskWidget);
    }

    var loadAfterPageSettles = function () {
      window.setTimeout(loadZendesk, 10000);
    };

    if (document.readyState === 'complete') {
      loadAfterPageSettles();
    } else {
      window.addEventListener('load', loadAfterPageSettles, { once: true });
    }
  }

  // ---- Stamped (product review badges + reviews widget) ----
  // Renders visible rating badges, so it must still load automatically — but its
  // ~216KB bundle + init no longer run during the busy initial-load window.
  window.tmgLoadStamped = function () {
    return loadScript(
      'stamped-widget',
      'https://cdn1.stamped.io/files/widget.min.js'
    ).then(function (ok) {
      if (ok && window.StampedFn && typeof window.StampedFn.init === 'function') {
        window.StampedFn.init({
          apiKey: 'pubkey-R3kK440GU94Lx6PRYbc8Ra2YODKMg9',
          storeUrl: '174584'
        });
      }
      return ok;
    });
  };

  // ---- CallRail (dynamic phone-number swap; analytics only) ----
  window.tmgLoadCallrail = function () {
    return loadScript(
      'callrail-swap',
      'https://cdn.callrail.com/companies/692845950/a5d09d8cb04064c8dfcb/12/swap.js'
    );
  };

  // ---- Microsoft Clarity (session analytics) ----
  // Loads as soon as the page has finished loading — no idle gap, interaction or
  // timeout gate, so sessions are captured for every visitor who reaches load.
  window.tmgLoadClarity = function () {
    if (window.clarity) return;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'vggwcrb6ck');
  };

  function setupClarity() {
    if (document.readyState === 'complete') {
      window.tmgLoadClarity();
    } else {
      window.addEventListener('load', window.tmgLoadClarity, { once: true });
    }
  }

  // Schedule non-visual/idle work in a real gap between tasks, with a timeout
  // fallback for browsers without requestIdleCallback (Safari).
  function whenIdle(fn, timeout) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: timeout || 4000 });
    } else {
      window.setTimeout(fn, 2000);
    }
  }

  // Vendors that must appear automatically but not compete with the critical
  // load: kick them off once the page has fully loaded, during the first idle gap.
  function setupIdleVendors() {
    var utmSource = new URLSearchParams(window.location.search).get('utm_source');
    var loadIdleVendors = function () {
      whenIdle(function () { window.tmgLoadStamped(); });
      if (utmSource && utmSource.trim()) {
        whenIdle(function () { window.tmgLoadCallrail(); });
      }
    };

    if (document.readyState === 'complete') {
      loadIdleVendors();
    } else {
      window.addEventListener('load', loadIdleVendors, { once: true });
    }
  }

  function setupDeferredVendors() {
    setupZendesk();
    setupIdleVendors();
    setupClarity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDeferredVendors, { once: true });
  } else {
    setupDeferredVendors();
  }
})();



  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".announcement-slider-container");
    const slider = document.getElementById("announcement-slider");

    if (container) {
      container.classList.add("is-visible");
    }

    // Guard: pages without an announcement slider (e.g. product pages) have no
    // #announcement-slider. Without this, `slider.children` threw an uncaught
    // TypeError that aborted the rest of this DOMContentLoaded handler.
    if (!slider) return;

    let slides = Array.from(slider.children).filter(slide => {
      return window.getComputedStyle(slide).display !== "none";
    });

    let currentIndex = 0;
    let isTransitioning = false;

    // Clone the first slide and append to end
    const firstClone = slides[0].cloneNode(true);
    firstClone.classList.add("clone");
    slider.appendChild(firstClone);
    slides.push(firstClone); // update slides list

    const totalSlides = slides.length;

    function updateSlider(index, animate = true) {
      slider.style.transition = animate ? 'transform 0.5s ease' : 'none';
      slider.style.transform = `translateX(-${index * 100}%)`;
    }

    function nextSlide() {
      if (isTransitioning) return;
      isTransitioning = true;

      currentIndex++;
      updateSlider(currentIndex);
    }

    function prevSlide() {
      if (isTransitioning) return;
      if (currentIndex === 0) {
        currentIndex = totalSlides - 2;
        updateSlider(currentIndex, false);
      } else {
        currentIndex--;
        updateSlider(currentIndex);
      }
      isTransitioning = true;
    }

    slider.addEventListener("transitionend", () => {
      // If we're on the clone, jump to real first slide
      if (slides[currentIndex]?.classList.contains("clone")) {
        slider.style.transition = "none";
        currentIndex = 0;
        updateSlider(currentIndex, false);
      }
      isTransitioning = false;
    });

    const nextBtn = document.querySelector(".announcement-nav.next");
    const prevBtn = document.querySelector(".announcement-nav.prev");

    if (nextBtn) nextBtn.addEventListener("click", nextSlide);
    if (prevBtn) prevBtn.addEventListener("click", prevSlide);

    setInterval(() => {
      nextSlide();
    }, 8000); // autoplay every 8s
  });
